import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../services/language.service';

@Component({
   selector: 'app-language',
   standalone: true,
   imports: [TranslateModule],
   templateUrl: './app-language.component.html',
   styleUrl: './app-language.component.scss',
})
export class AppLanguageComponent {
   /** Render as a row of the navbar menu rather than a pill on the bar. */
   @Input() inMenu = false;

   constructor(public languageService: LanguageService) {}

   changeLanguage(event: Event) {
      this.languageService.choose((event.target as HTMLSelectElement).value);
   }
}
